module.exports = __webpack_public_path__ + "img/vertical_mid_frame_bottom.de5eac3b.png";